import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  Textarea,
  useToast,
  VStack,
  Box,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import api from "utils/api";
import { useErrorHandler } from "hooks/useErrorHandler";

export default function AbonelikSonlandirModal({ isOpen, onClose, abonelik, onSuccess }) {
  const toast = useToast();
  const { handleError } = useErrorHandler(); // Merkezi error handling
  const [sebep, setSebep] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setSebep("");
      setLoading(false);
    }
  }, [isOpen]);

  const handleSave = async () => {
    if (!sebep.trim()) {
      toast({ title: "Sebep gerekli", status: "warning", duration: 3000, isClosable: true });
      return;
    }
    if (!abonelik?.cihaz_id) {
      toast({ title: "Cihaz bilgisi bulunamadı", status: "error", duration: 3000, isClosable: true });
      return;
    }
    try {
      setLoading(true);
      const res = await api.post(`/api/abonelikler/${abonelik.cihaz_id}/sonlandir`, { 
        sebep: sebep.trim()
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.detail || "Abonelik sonlandırılamadı");

      toast({
        title: "Abonelik sonlandırıldı",
        description: "Cihaz Traccar'da devre dışı bırakıldı, abonelik pasif edildi.",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      onSuccess?.();
      onClose?.();
    } catch (err) {
      // Merkezi error handling - Güvenli mesaj göster
      handleError(err, "Abonelik sonlandırma hatası");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered motionPreset="slideInBottom">
      <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
      <ModalContent borderRadius="2xl" boxShadow="xl" maxW="520px" bg="white" p={1}>
        {/* Header */}
        <Box bg="white" p={4} borderBottom="1px solid" borderColor="gray.200">
          <ModalCloseButton size="sm" />
          <VStack spacing={1} align="start">
            <Text fontSize="lg" fontWeight="medium" color="gray.800">
              {abonelik?.satis_turu === "Kiralık" ? "Kiralama Sonlandır" : "Aboneliği Sonlandır"}
            </Text>
            <Text fontSize="xs" color="gray.600">
              {abonelik?.satis_turu === "Kiralık" 
                ? "Kiralama sonlandırmak için sebep girin" 
                : "Aboneliği sonlandırmak için sebep girin"}
            </Text>
          </VStack>
        </Box>
        <ModalBody px={6} py={4}>
          <Text fontSize="sm" mb={2}>
            Bu işlem cihazı Traccar'da devre dışı bırakır ve aboneliği manuel sonlandırılmış olarak işaretler.
          </Text>
          <FormControl>
            <FormLabel fontSize="sm" color="gray.600">Sebep (Zorunlu)</FormLabel>
            <Textarea
              variant="flushed"
              size="sm"
              placeholder="Sebep girin"
              value={sebep}
              onChange={(e) => setSebep(e.target.value)}
              rows={4}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter px={6} py={4}>
          <Button variant="ghost" mr={3} onClick={onClose} size="sm">
            İptal
          </Button>
          <Button colorScheme="red" onClick={handleSave} isLoading={loading} size="sm">
            {abonelik?.satis_turu === "Kiralık" ? "Kiralama Sonlandır" : "Sonlandır"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

